import { keys } from './keys.ts';

export const articlesUrlBase = {
  [keys.articleTypes.blogPost]: '/blog',
  [keys.articleTypes.crisisUpdate]: '/crisis-updates',
  [keys.articleTypes.pressRelease]: '/press/press-releases',
};
